<template>
    <div>
        <el-form :rules="rules" ref="ruleForm"  :model="newRecord"  label-width="80px">
            <el-form-item label="联系人" required prop="customerName">
                <el-input v-model="newRecord.customerName" size="small" placeholder="请输入跟进联系人"></el-input>
            </el-form-item>
            <el-form-item label="联系电话" required prop="mobile">
                <el-input v-model="newRecord.mobile" size="small" placeholder="请输入跟进联系电话"></el-input>
            </el-form-item>
            <el-form-item label="跟进日期" required>
                <el-form-item prop="date1">
                    <el-date-picker
                        v-model="newRecord.followDate"
                        type="date"
                        value-format="yyyy-MM-dd"
                        format="yyyy-MM-dd"
                        placeholder="选择日期"
                        :clearable="true"
                    />
                </el-form-item>
            </el-form-item>
            <el-form-item label="跟进内容" prop="content" required>
                <el-input type="textarea" v-model="newRecord.content"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="submitNewRecord('ruleForm')" size="mini">提交</el-button>
                <el-button type="info" @click="$emit('close')" size="mini">取消</el-button>
            </el-form-item>
        </el-form>
        <!-- <form @submit.prevent="submitNewRecord">
        <div>
          <label>客户姓名:</label>
          <input v-model="newRecord.customerName" placeholder="姓名" required />
        </div>
        <div>
          <label>联系电话:</label>
          <input v-model="newRecord.mobile" placeholder="电话" required />
        </div>
        <div>
          <label>跟进日期:</label>
          <el-date-picker
            v-model="newRecord.followDate"
            type="date"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
            placeholder="选择日期"
            :clearable="true"
          />
        </div>
        <div>
          <label>跟进内容:</label>
          <input v-model="newRecord.content" placeholder="内容" required />
        </div>
        <div>
          <label>状态:</label>
          <select v-model="newRecord.status">
            <option value="已跟进">已跟进</option>
            <option value="待跟进">待跟进</option>
          </select>
        </div>
        <el-row>
        <button type="submit">提交</button><button type="button" @click="$emit('close')">取消</button>
        </el-row>
      </form> -->
    </div>
  </template>
  <script>
 import { formatDate } from '@/utils/util'
  export default {
    props: {
        student: {
            type: Object,
            required: true
        }
    },
    data () {
      return {
        newRecord: {
          customerName: this.student.real_name,
          mobile: this.student.mobile,
          followDate: formatDate(new Date()),
          content: ''
        },
        rules: {
          customerName: [
            { required: true, message: '请输入跟进联系人', trigger: 'blur' },
            { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
          ],
          mobile: [
            { required: true, message: '请输入跟进联系电话', trigger: 'change' }
          ],
          followDate: [
            { type: 'date', required: true, message: '请选择日期', trigger: 'change' }
          ],
          content: [
            { required: true, message: '请填写跟进内容', trigger: 'blur' }
          ]
        }
      }
    },
    methods: {
      submitNewRecord (formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            const record = {
                id: Date.now(),
                ...this.newRecord
            }
            this.$emit('submit', record)
            this.resetNewRecord()
          } else {
            console.log('error submit!!')
            return false
          }
        })
      },
      resetNewRecord () {
        this.newRecord = {
          customerName: this.student.real_name,
          mobile: this.student.mobile,
          followDate: formatDate(new Date()),
          content: ''
        }
      }
    }
  }
  </script>
  <style scoped>
  form {
    display: flex;
    flex-direction: column;
  }
  div {
    margin-bottom: 10px;
  }
  </style>



// WEBPACK FOOTER //
// src/components/NewRecordForm.vue